import axios from "axios";
import { BASE_URL } from "../config/config";
import { OpenVendor, OpenVendorOptions } from "./vendors.types";

export const listOpenVendors = async (options?: OpenVendorOptions): Promise<OpenVendor[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/v2/vendors/open`, {
      params: {
        ...options,
      },
    });

    return response.data?.data || [];
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to fetch vendors");
  }
};
